import { createCustomBzTheme, dialogSizing } from '../../../styles/mui-next-theme';

const myDialogTheme = {
  MuiDialog: {
    root: {
      alignItems: 'center'
    },
    ...dialogSizing
  },
  MuiDialogTitle: {
    root: {
      padding: '24px',
      paddingTop: '20px',
      paddingBottom: '0px',
      fontSize: '1.6rem',
      color: 'unset'
    }
  }
};

const theme = createCustomBzTheme(myDialogTheme);

export default theme;
